import {observer} from "mobx-react";
import {useNavigate, useSearchParams} from "react-router";
import {Page, PageContentTitle} from "../../ui";
import {SlsProcessList} from "./SlsProcessList";
import {SlsWarehouseList} from "./SlsWarehouseList";
import {pageQueryStore, slsCustomerCabinetStore, slsPlacementCartStore, slsPrinterStore} from "../../../store";
import {SlsPlacementBatchClosingDialog} from "./SlsPlacementBatchClosingDialog";
import {useState} from "react";
import {PlacementProcessDocumentExistenceFilterDto, PlacementProcessStatusDto} from "../../../api/sls";

export type SlsTabType = 'warehouse'

interface SlsOverviewPageProps {
    tab?: SlsTabType
}


const SlsOverviewPage = observer(function StorageOverviewPage({tab}: SlsOverviewPageProps) {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [openButtonLoading, setOpenButtonLoading] = useState(false)

    if (!tab) {
        pageQueryStore.restore('sls', searchParams, setSearchParams, {
            status: [PlacementProcessStatusDto.ACTIVE],
            documentExistence: [PlacementProcessDocumentExistenceFilterDto.EXISTS],
            fromRelative: 'PT48H'
        })
    }

    const pageActions = tab === 'warehouse' ? [
        {
            label: 'Neuen Lagerstandort anlegen',
            icon: 'add',
            action: () => {
                navigate(`/sls/warehouse/create`)
            }
        }
    ] : [
        {
            label: 'Neuen Einlagerungsprozess anlegen',
            icon: 'add',
            action: () => {
                navigate(`/sls/create`)
            }
        }
    ]

    return <Page cssSuffix={"user"}
                 breadcrumb={[
                     {
                         link: `/sls`,
                         label: 'Einlagerung'
                     }
                 ]}
                 actions={pageActions}
    >
        <SlsPlacementBatchClosingDialog />
        <PageContentTitle
            actionItem={<>
                {!tab && !slsPlacementCartStore.isEmpty() && <>
                    <button
                        className={`button is-rounded is-warning ${openButtonLoading ? 'is-loading' : ''}`}
                        style={{paddingRight: 'calc(var(--bulma-button-padding-horizontal) / 2 )'}}
                        disabled={slsPlacementCartStore.isEmpty() || openButtonLoading}
                        onClick={async (e) => {
                            slsCustomerCabinetStore.reset()
                            setOpenButtonLoading(true)
                            await Promise.all([
                                slsPrinterStore.load(),
                                slsCustomerCabinetStore.load(slsPlacementCartStore.customerId!)
                            ])
                            slsPlacementCartStore.dialogOpen = true
                            setOpenButtonLoading(false)
                        }}
                    >
                        <span
                            className="material-symbols-outlined"
                        >add_shopping_cart</span>
                        Stapelabschluss
                        <span className="tag is-rounded" style={{marginLeft: '1em'}}>{slsPlacementCartStore.items.length}</span>
                    </button>
                </>}
            </>}
        >
            <div>
                <div style={{display: "flex", alignItems: 'center'}}>
                    <div style={{paddingRight: '1em'}}>
                        <button className={`button is-rounded is-small is-info ${!tab ? '' : 'is-outlined'}`}
                                onClick={() => {
                                    navigate(`/sls`)
                                }}>Einlagerungsprozesse
                        </button>
                    </div>
                    <div style={{paddingRight: '1em'}}>
                        <button className={`button is-rounded is-small is-info 
                            ${tab === 'warehouse' ? '' : 'is-outlined'}`}
                                onClick={() => {
                                    navigate(`/sls/warehouse`)
                                }}>Lagerstandorte
                        </button>
                    </div>
                </div>
            </div>
        </PageContentTitle>

        {!tab && (
            <>
                <SlsProcessList/>
            </>
        )}
        {tab === 'warehouse' && <SlsWarehouseList/>}
    </Page>
})

export {
    SlsOverviewPage
}
